import { render, staticRenderFns } from "./Veditor.vue?vue&type=template&id=596eb6f6"
import script from "./Veditor.vue?vue&type=script&lang=js"
export * from "./Veditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports